module.exports = __webpack_public_path__ + "static/resetBotonTrans-80a385db1a220bb7773776f3b4ee6ea8.png";